// extracted by mini-css-extract-plugin
export default {"input":"styles_input__Gxly2","icon":"styles_icon__2pF-t"};